import styles from './Spinner.module.css';

export interface SpinnerProps {
  readonly size?: number;
  readonly label?: string;
}

export function Spinner({ size = 16, label }: SpinnerProps) {
  return (
    <span
      className={styles.spinner}
      style={{ width: size, height: size }}
      role="status"
      aria-label={label ?? 'Loading'}
    />
  );
}
